export function getFirstName(fullName = ''): string {
	return fullName.trim().split(' ')[0] || '';
}
